import { api } from './client';
import type { NavCounts } from '@/types';

export const navigationApi = {
  async counts(): Promise<NavCounts> {
    const { data } = await api.get<NavCounts>('/nav-counts/');
    return data;
  },
};
